import type { GeographicReview } from '../../functions/src/common/geographicConflict';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebaseConfig';
import type { ConsultantReportContent, ConsultantReportInputs, ConsultantReportService } from '../../functions/src/common/consultantReport';

export type { ConsultantReportContent, ConsultantReportInputs, ConsultantReportService };
export type ReportOrganization = { id: string; name: string };
export type ReportTargets = { users: Array<{ uid: string; email: string; name: string }>;
    requests: Array<{ id: string; reference: string; serviceName: string }>;
    chats: Array<{ id: string; participantUid: string; participantName: string; managerName: string }> };
export type ReportDraft = { geographicReview?: GeographicReview | null; id: string; organizationId: string; organizationName: string; serviceId: string;
    serviceName: string; inputs: ConsultantReportInputs; report?: ConsultantReportContent; version: number;
    status: 'generating' | 'draft' | 'error' | 'delivered'; generationError?: string;
    reportId?: string; deliveryKind?: string; emailRecipientCount?: number; createdAt?: string; updatedAt?: string };
export type ReportEmailSummary = { sent: number; pending: number; failed: number; suppressed: number };

export async function consultantReports<T>(action: string, data: Record<string, unknown> = {}): Promise<T> {
    const result = await httpsCallable(functions, 'manageConsultantReports', { timeout: 540000 })({ action, ...data });
    return result.data as T;
}
